module.exports = "pegasus/assets/tech/realty/103.png";